import { useEffect, useState } from "react";

import { PageProps, UpdateDomTitleForForm } from "@ezhou/core";

import { Account } from "../../model/model";
import { OrganizationDataListRequestModel } from "../../model/apiModel/requestmodel";
import { getUserProfileFromCache } from "../../services/userSettingService";

import { dummyJournalEntryTypeMappingRow, journalEntryTypeMappingColumns } from "./model/metaData";
import { ActionButtonProps, JournalEntryTypeMapping, MappingModelBase } from "./model/model";
import { BaseMappings } from "./BaseMappings";
import { JournalEntryTypes } from "./JournalEntryTypes";

const JournalEntryTypeMappings = (pageProps: PageProps) => {
  const logger = pageProps.loggerProvider.getLogger("JournalEntryTypeMappings");
  logger.debug("Rendering JournalEntryTypeMappings page");

  const organizationId = getUserProfileFromCache(pageProps.dataStore).defaultOrganization;
  const [accountList, setAccountList] = useState<Account[]>([]);

  useEffect(() => {
    UpdateDomTitleForForm(pageProps);
  });

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const httpClient = pageProps.appUtil.httpClients["eAccountingService"];
        const response = await httpClient.post<Account[], OrganizationDataListRequestModel>(
          "/accounts/get-all",
          { organizationId: organizationId, },
          (err: any) => {
            throw err;
          }
        );
        setAccountList(response || []);
      } catch (error) {
        logger.error("Failed to fetch accounts", error);
      }
    };
    fetchAccounts();
  }, [organizationId, pageProps.appUtil.httpClients]);

  const journalEntryTypesButton: ActionButtonProps = {
    icon: "inserttable",
    hint: "View Journal Entry Types",
    contentType: "journalEntryTypes",
  };

  const getPopupContent = (contentType: string, selectedMapping: any, hidePopup: () => void) => {
    if (contentType === "journalEntryTypes") {
      return (
        <JournalEntryTypes
          pageProps={pageProps}
          organizationId={1}
          mappingData={selectedMapping}
          logger={logger}
          onClosing={hidePopup}
          accountList={accountList}
          onSaving={onJournalEntryTypesSaving}
        />
      );
    }
    return undefined;
  };

  const additionalDataToBeFilteredForForm = ["journalEntryTypes"];

  const baseUrl = "journal-entry-type-mappings";

  const onJournalEntryTypesSaving = async (mappingData: MappingModelBase) => {
    const journalEntryTypeMapping = mappingData as JournalEntryTypeMapping;
    logger.debug("Journal Entry Type Mapping onJournalEntryTypesSaving: ", journalEntryTypeMapping.journalEntryTypes);
    
    const updateUrl = `/${baseUrl}/update-fields`;
    const updateData = {
      key: {
        organizationId: organizationId,
        mappingName: journalEntryTypeMapping.mappingName,
      },
      updateValues: {
        JournalEntryTypes: journalEntryTypeMapping.journalEntryTypes,
      },
    };
    await pageProps.appUtil.httpClients["eAccountingService"].put(
      updateUrl,
      updateData,
      (err) => {
        throw err;
      },
    );
  };

  const beforeSave = async (data: any) => {
    (data as JournalEntryTypeMapping).journalEntryTypes = [];
    return data;
  };

  return (
    <BaseMappings
      logger={logger}
      {...pageProps}
      baseUrl={baseUrl}
      formTitle="Journal Entry Type Mapping"
      dummyRow={dummyJournalEntryTypeMappingRow}
      columnConfigs={journalEntryTypeMappingColumns}
      additionalButtons={[journalEntryTypesButton]}
      getPopupContent={getPopupContent}
      additionalDataToBeFilteredForForm={additionalDataToBeFilteredForForm}
      beforeSave={beforeSave}
    />
  );
};

export default JournalEntryTypeMappings;
